import { parseQueryParam } from "../hooks/useQueryParams";
import { OrganizationType } from "../models/shared/Organization";

export const getTypeFromDomain = (): OrganizationType => {
    const params = parseQueryParam()
    if (window.location.host.includes(OrganizationType.cgh) || params.orgType === OrganizationType.cgh) {
        return OrganizationType.cgh;
    }

    return OrganizationType.arbTask;
}
